/* Pata & Casa. Native Shopify forms remain usable without JavaScript. */
(() => {
  "use strict";
  const body = document.body;
  const root = PataCommerce.localeRoot(body.dataset.shopRoot);
  const currency = body.dataset.currency || "BRL";
  const locale = body.dataset.locale || "pt-BR";
  const favoriteKey = "pata-casa:shopify:favorites:v1";
  const validHandle = (value) =>
    typeof value === "string" && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
  let favorites = readFavorites();
  let comparison = [];
  let toastTimer;
  let requestGeneration = 0;

  function readFavorites() {
    try {
      const value = JSON.parse(localStorage.getItem(favoriteKey) || "[]");
      return Array.isArray(value)
        ? [...new Set(value.filter(validHandle))].slice(0, 100)
        : [];
    } catch {
      return [];
    }
  }
  function saveFavorites() {
    try {
      localStorage.setItem(favoriteKey, JSON.stringify(favorites));
      return true;
    } catch {
      return false;
    }
  }
  function el(tag, text, className) {
    const node = document.createElement(tag);
    if (text != null) node.textContent = text;
    if (className) node.className = className;
    return node;
  }
  function money(value) {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
    }).format(value / 100);
  }
  function announce(message) {
    const dialog = document.querySelector("dialog[open]");
    if (dialog) {
      const status = dialog.querySelector(".dialog-status");
      if (status) status.textContent = message;
      return;
    }
    const toast = document.querySelector("[data-toast]");
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toast.hidden = true;
    }, 4200);
  }
  function syncChoices() {
    document.querySelectorAll("[data-favorite]").forEach((button) => {
      const active = favorites.includes(button.dataset.favorite);
      button.setAttribute("aria-pressed", String(active));
      button.textContent = active ? "♥" : "♡";
    });
    document.querySelectorAll("button[data-compare]").forEach((button) => {
      const active = comparison.includes(button.dataset.compare);
      button.setAttribute("aria-pressed", String(active));
      button.textContent = active ? "✓ Selecionado" : "Comparar";
    });
    const bar = document.querySelector("[data-compare-bar]");
    const count = document.querySelector("[data-compare-count]");
    const trigger = document.querySelector('[data-open="compareDialog"]');
    if (bar) bar.hidden = comparison.length === 0;
    if (count) count.textContent = comparison.length;
    if (trigger) trigger.disabled = comparison.length < 2;
    document.body.classList.toggle("has-comparison", comparison.length > 0);
  }
  async function fetchProduct(handle) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(
        `${root}products/${encodeURIComponent(handle)}.js`,
        {
          headers: { Accept: "application/json" },
          signal: controller.signal,
        },
      );
      if (response.status === 404) return { handle, missing: true };
      if (!response.ok) throw new Error("request_failed");
      const data = await response.json();
      if (typeof data.title !== "string" || !Number.isFinite(data.price))
        throw new Error("invalid_product");
      return { ...data, handle };
    } finally {
      clearTimeout(timeout);
    }
  }
  function productLink(product) {
    const link = el("a", product.title, "text-link");
    link.href = `${root}products/${encodeURIComponent(product.handle)}`;
    return link;
  }
  function productImage(product) {
    if (!product.featured_image) return null;
    try {
      const url = new URL(product.featured_image, location.origin);
      if (url.protocol !== "https:") return null;
      url.searchParams.set("width", "360");
      const img = el("img");
      img.src = url.href;
      img.alt = product.title;
      img.width = 180;
      img.height = 180;
      img.loading = "lazy";
      return img;
    } catch {
      return null;
    }
  }
  function priceText(product) {
    return `${product.price_min !== product.price_max ? "A partir de " : ""}${money(product.price)}`;
  }
  function renderFavorites(container, results) {
    if (!results.length) {
      container.append(
        el(
          "div",
          "Guarda os teus favoritos tocando no coração de cada produto.",
          "empty",
        ),
      );
      return;
    }
    const list = el("div", null, "saved-products");
    results.forEach((result) => {
      const item = el("article", null, "saved-product");
      if (result.status === "fulfilled") {
        const p = result.value;
        if (p.missing) {
          item.append(el("p", "Este produto já não está disponível."));
        } else {
          const image = productImage(p);
          if (image) item.append(image);
          item.append(
            productLink(p),
            el("strong", priceText(p)),
            el(
              "p",
              p.available
                ? "Escolha as opções na página do produto."
                : "Indisponível no momento.",
              "muted",
            ),
          );
        }
        const remove = el("button", "Remover dos favoritos", "text-link");
        remove.type = "button";
        remove.dataset.removeSaved = p.handle;
        item.append(remove);
      } else
        item.append(
          el(
            "p",
            "Não conseguimos consultar um dos produtos. Tenta novamente.",
          ),
        );
      list.append(item);
    });
    container.append(list);
  }
  function renderComparison(container, results) {
    const list = results
      .filter((r) => r.status === "fulfilled" && !r.value.missing)
      .map((r) => r.value);
    if (list.length !== results.length)
      container.append(
        el(
          "p",
          "Alguns produtos não puderam ser consultados. Tenta novamente ou ajuste a seleção.",
          "muted",
        ),
      );
    if (list.length < 2) {
      container.append(
        el("p", "São necessários dois produtos disponíveis para comparar."),
      );
      return;
    }
    const scroll = el("div", null, "comparison-scroll");
    scroll.tabIndex = 0;
    scroll.setAttribute("role", "region");
    scroll.setAttribute(
      "aria-label",
      "Tabela de comparação, deslize para ver todas as colunas",
    );
    const table = el("table");
    table.append(
      el(
        "caption",
        "Preços atuais. Escolha a variante na página de cada produto.",
      ),
    );
    const head = el("thead"),
      headerRow = el("tr");
    const label = el("th", "Sua escolha");
    label.scope = "col";
    headerRow.append(label);
    list.forEach((p) => {
      const th = el("th");
      th.scope = "col";
      const img = productImage(p);
      if (img) th.append(img);
      th.append(productLink(p));
      headerRow.append(th);
    });
    head.append(headerRow);
    table.append(head);
    const tbody = el("tbody");
    [
      ["Preço", priceText],
      ["Categoria", (p) => p.type || "Acessório pet"],
      [
        "Disponibilidade",
        (p) => (p.available ? "Há opções disponíveis" : "Esgotado"),
      ],
      [
        "Opções",
        (p) =>
          (p.variants || [])
            .map((v) => v.public_title || v.title)
            .filter((v) => v !== "Default Title")
            .join(" · ") || "Modelo único",
      ],
    ].forEach(([name, get]) => {
      const row = el("tr"),
        th = el("th", name);
      th.scope = "row";
      row.append(th);
      list.forEach((p) => row.append(el("td", get(p))));
      tbody.append(row);
    });
    table.append(tbody);
    scroll.append(table);
    container.append(scroll);
  }
  async function fillDialog(dialog) {
    const generation = ++requestGeneration;
    const isFavorites = dialog.id === "favoritesDialog";
    const handles = [...(isFavorites ? favorites : comparison)];
    const container = dialog.querySelector(
      isFavorites ? "[data-favorite-list]" : "[data-comparison-list]",
    );
    container.replaceChildren(el("p", "Consultando os produtos…", "muted"));
    container.setAttribute("aria-busy", "true");
    const results = await PataCommerce.settledMap(handles, fetchProduct, 4);
    if (generation !== requestGeneration || !dialog.open) return;
    container.replaceChildren();
    container.removeAttribute("aria-busy");
    if (isFavorites) renderFavorites(container, results);
    else renderComparison(container, results);
    if (results.some((r) => r.status === "rejected")) {
      const retry = el("button", "Tentar novamente", "button blue");
      retry.type = "button";
      retry.addEventListener("click", () => fillDialog(dialog));
      container.append(retry);
    }
  }
  function showDialog(id) {
    const dialog = document.getElementById(id);
    if (!dialog || dialog.open) return;
    dialog.querySelector(".dialog-status").textContent = "";
    dialog.showModal();
    fillDialog(dialog);
  }
  function selectMedia(section, id) {
    const panels = [...section.querySelectorAll("[data-media-panel]")];
    const target =
      panels.find((p) => p.dataset.mediaPanel === String(id)) || panels[0];
    panels.forEach((panel) => {
      panel.hidden = panel !== target;
      if (panel !== target)
        panel.querySelectorAll("video").forEach((video) => video.pause());
    });
    section
      .querySelectorAll("[data-show-media]")
      .forEach((b) =>
        b.setAttribute(
          "aria-pressed",
          String(b.dataset.showMedia === target?.dataset.mediaPanel),
        ),
      );
  }
  function syncVariant(section, updateURL = false) {
    const select = section.querySelector("[data-variant-select]");
    if (!select) return;
    const selected = select.selectedOptions[0];
    if (!selected) return;
    const available = selected.dataset.available === "true";
    section.querySelector("[data-variant-price]").textContent =
      selected.dataset.price;
    section.querySelector("[data-mobile-price]").textContent =
      selected.dataset.price;
    const compare = section.querySelector("[data-variant-compare]");
    compare.textContent = selected.dataset.compare;
    compare.hidden = !selected.dataset.compare;
    section.querySelector("[data-stock]").textContent = available
      ? "Disponível para compra"
      : "Indisponível nesta opção";
    section.querySelectorAll("[data-product-submit]").forEach((b) => {
      b.disabled = !available;
      b.textContent = available ? "Adicionar ao carrinho" : "Esgotado";
    });
    const input = section.querySelector('[name="quantity"]');
    input.min = selected.dataset.min || "1";
    input.step = selected.dataset.step || "1";
    if (selected.dataset.max) input.max = selected.dataset.max;
    else input.removeAttribute("max");
    input.value = input.min;
    syncQuantity(input);
    selectMedia(section, selected.dataset.media);
    if (updateURL) {
      const url = new URL(location.href);
      url.searchParams.set("variant", selected.value);
      history.replaceState({}, "", url);
    }
  }
  function syncQuantity(input) {
    if (!input) return;
    input.closest(".qty")?.querySelectorAll("[data-quantity]").forEach((button) => {
      const next = PataCommerce.nextQuantity(
        input.value, Number(button.dataset.quantity), input.min, input.step, input.max,
      );
      button.disabled = input.disabled || (input.value !== "" && next === Number(input.value));
    });
  }
  function resetSubmitting() {
    document.querySelectorAll("[data-submitting]").forEach((form) => {
      delete form.dataset.submitting;
      form.removeAttribute("aria-busy");
    });
    document.querySelectorAll("[data-submit-label]").forEach((button) => {
      button.textContent = button.dataset.submitLabel;
      delete button.dataset.submitLabel;
      button.removeAttribute("aria-disabled");
    });
  }
  function closeMobileMenus(restoreFocus = false) {
    document.querySelectorAll(".mobile-menu[open]").forEach((menu) => {
      menu.open = false;
      if (restoreFocus) menu.querySelector("summary")?.focus();
    });
  }
  function initialize(scope = document) {
    scope
      .querySelectorAll(".js-only")
      .forEach((node) => node.classList.remove("js-only"));
    scope
      .querySelectorAll("[data-product-section]")
      .forEach((section) => syncVariant(section));
    scope.querySelectorAll(".qty input").forEach(syncQuantity);
    syncChoices();
  }
  document.addEventListener("click", (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.closest(".mobile-menu") || target.closest(".mobile-menu a"))
      closeMobileMenus();
    const open = target.closest("[data-open]");
    if (open) showDialog(open.dataset.open);
    const close = target.closest("[data-close]");
    if (close) document.getElementById(close.dataset.close)?.close();
    const favorite = target.closest("[data-favorite]");
    if (favorite && validHandle(favorite.dataset.favorite)) {
      const handle = favorite.dataset.favorite;
      if (favorites.includes(handle))
        favorites = favorites.filter((h) => h !== handle);
      else if (favorites.length < 100) favorites.push(handle);
      else {
        announce("Você já tem 100 favoritos. Remova um para guardar outro.");
        return;
      }
      const saved = saveFavorites();
      syncChoices();
      announce(
        saved
          ? "Favoritos atualizados neste navegador."
          : "Favoritos disponíveis apenas nesta visita.",
      );
    }
    const remove = target.closest("[data-remove-saved]");
    if (remove) {
      favorites = favorites.filter((h) => h !== remove.dataset.removeSaved);
      const saved = saveFavorites();
      syncChoices();
      fillDialog(document.getElementById("favoritesDialog"));
      announce(
        saved
          ? "Favorito removido."
          : "Removido nesta visita; o navegador não permitiu salvar.",
      );
    }
    const compare = target.closest("button[data-compare]");
    if (compare) {
      const handle = compare.dataset.compare;
      if (comparison.includes(handle))
        comparison = comparison.filter((h) => h !== handle);
      else if (comparison.length < 3) comparison.push(handle);
      else announce("Compare até 3 produtos por vez.");
      syncChoices();
    }
    if (target.closest("[data-clear-compare]")) {
      comparison = [];
      syncChoices();
    }
    const media = target.closest("[data-show-media]");
    if (media)
      selectMedia(
        media.closest("[data-product-section]"),
        media.dataset.showMedia,
      );
    const quantity = target.closest("[data-quantity]");
    if (quantity) {
      const input = quantity.closest(".qty").querySelector("input");
      input.value = String(
        PataCommerce.nextQuantity(
          input.value,
          Number(quantity.dataset.quantity),
          input.min,
          input.step,
          input.max,
        ),
      );
      input.dispatchEvent(new Event("input", { bubbles: true }));
    }
  });
  document.addEventListener("change", (event) => {
    if (event.target.matches("[data-variant-select]"))
      syncVariant(event.target.closest("[data-product-section]"), true);
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeMobileMenus(true);
  });
  document.addEventListener("input", (event) => {
    if (event.target.matches(".qty input")) syncQuantity(event.target);
    if (event.target.closest("#CartForm") && event.target.name === "updates[]")
      document.querySelector("[data-cart-dirty]").hidden = false;
  });
  document.addEventListener("submit", (event) => {
    if (event.defaultPrevented || !event.target.matches(".product-form")) return;
    if (event.target.dataset.submitting) {
      event.preventDefault();
      return;
    }
    event.target.dataset.submitting = "true";
    event.target.setAttribute("aria-busy", "true");
    // Include the mobile submit button associated through its form attribute.
    [...event.target.elements].filter((node) => node.matches("[data-product-submit]")).forEach((button) => {
      button.dataset.submitLabel = button.textContent;
      button.textContent = "Adicionando…";
      // Keep successful form controls enabled for Shopify's native submission.
      button.setAttribute("aria-disabled", "true");
    });
  });
  document.querySelectorAll("dialog").forEach((dialog) => {
    dialog.addEventListener("click", (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom
      )
        dialog.close();
    });
    dialog.addEventListener("close", () => {
      requestGeneration++;
    });
  });
  window.addEventListener("pageshow", () => {
    resetSubmitting();
    document.querySelectorAll(".qty input").forEach(syncQuantity);
  });
  window.addEventListener("storage", (event) => {
    if (event.key === favoriteKey || event.key === null) {
      favorites = readFavorites();
      syncChoices();
      if (document.getElementById("favoritesDialog")?.open)
        fillDialog(document.getElementById("favoritesDialog"));
    }
  });
  document.addEventListener("shopify:section:load", (event) =>
    initialize(event.target),
  );
  initialize();
})();
